import { useState } from "react";
import { ImageOff } from "lucide-react";

const DRIVE_ID_RX = /(?:\/d\/|[?&]id=)([\w-]{10,})/;

const collectPhotos = (wo) => {
  const seen = new Set();
  const out = [];
  const add = (id, link) => {
    const fid = id || (link || "").match(DRIVE_ID_RX)?.[1];
    if (!fid || seen.has(fid)) return;
    seen.add(fid);
    out.push({ id: fid, href: link || `https://drive.google.com/file/d/${fid}/view` });
  };
  (wo?.start_photos || []).forEach(p => add(p?.id, p?.webViewLink));
  (wo?.billing?.photo_urls || []).forEach(u => add(null, u));
  (wo?.billing?.photos || []).forEach(u => typeof u === "string" && add(null, u));
  return out;
};

const Thumb = ({ id, alt }) => {
  const [failed, setFailed] = useState(false);
  if (failed) return <div className="w-full h-full grid place-items-center text-zinc-500"><ImageOff className="w-5 h-5" /></div>;
  return <img src={`https://drive.google.com/thumbnail?id=${id}&sz=w200`} alt={alt} onError={() => setFailed(true)}
    referrerPolicy="no-referrer" loading="lazy" className="w-full h-full object-cover" />;
};

export const WOTechEvidence = ({ wo }) => {
  const notes = (wo?.billing?.notes || "").trim();
  const photos = collectPhotos(wo);
  const empty = !notes && photos.length === 0;
  return (
    <div className="border border-input rounded-sm p-2.5 space-y-2" data-testid="wo-tech-evidence">
      <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-semibold">Laporan Teknisi</div>
      {empty && <div className="text-[12px] text-zinc-500" data-testid="wo-tech-evidence-empty">Belum ada data dari teknisi</div>}
      {notes && (
        <div className="text-[12px] whitespace-pre-wrap" data-testid="wo-tech-notes">{notes}</div>
      )}
      {photos.length > 0 && (
        <div className="flex flex-wrap gap-2" data-testid="wo-tech-photos">
          {photos.map((p, i) => (
            <a key={p.id} href={p.href} target="_blank" rel="noreferrer"
              className="block w-16 h-16 rounded-sm overflow-hidden border border-input hover:opacity-80 transition-opacity"
              data-testid={`wo-tech-photo-${i}`}>
              <Thumb id={p.id} alt={`Foto ${i + 1}`} />
            </a>
          ))}
        </div>
      )}
    </div>
  );
};
